import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BootstrapModule } from '../bootstrap.module';
import { RouterModule } from '@angular/router';
import { CampaignService } from './campaign.service';
import { ReactiveFormsModule,FormsModule  } from '@angular/forms';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { HttpClientModule } from '@angular/common/http';
import { CampaignListComponent } from './list/list.component';
import { CampaignFormComponent } from './form/form.component';
import { CampaignTransactionsComponent } from './campaign-transactions/campaign-transactions.component';
import { MatFormFieldModule, MatAutocompleteModule, MatInputModule, MatDatepickerModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

// import { CampaignFormComponent } from './form/form.component';
import { TooltipModule } from 'ngx-bootstrap';
import { CampaignGuard } from './campaign.guard';
import { CampaignListGuard } from './campaign-list.guard';
import { TransactionListGuard } from './transaction-list.guard';
import { NgxLoadingModule } from 'ngx-loading';

@NgModule({
  imports: [
    CommonModule,
    BootstrapModule,
    RouterModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    BrowserAnimationsModule,
    MatInputModule,
    HttpClientModule,
    TooltipModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    FormsModule
  ],
  declarations: [
    CampaignListComponent,
    CampaignFormComponent,
    CampaignTransactionsComponent
    // KeysPipe,
  ],
  exports: [
    CampaignFormComponent,
    CampaignTransactionsComponent
  ]
})
export class CampaignModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CampaignModule,
      providers: [
        CampaignService,
        CampaignGuard,
        CampaignListGuard,
        TransactionListGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/campaign/campaign.module.ts